import { ActionCreator } from "redux";
import {
  ChangeLanguageAction,
  ToggleLanguageSelectionVisibilityAction,
  LoadLanguageServiceFromServerAction
} from "./type";
import {
  CHANGE_LANGUAGE,
  TOGGLE_LANGUAGE_SELECTION_VISIBILITY,
  LOAD_LANGUAGE_SERVICE_FROM_SERVER
} from "./constants";
import { LanguageCodes } from "../../constants/languages";
import { LanguageResourceServiceDto } from "../../dtos/KioskDtos.dtos";

/**
 * @name changeLanguage
 * @constructs ChangeLanguageAction
 * @param lang 
 */
export const changeLanguage: ActionCreator<ChangeLanguageAction> = (lang: LanguageCodes) => ({
    type: CHANGE_LANGUAGE,
    payload: {
        lang
    },
});

export const toggleLanguageSelectionVisibility: ActionCreator<ToggleLanguageSelectionVisibilityAction> = (show: boolean) => ({
    type: TOGGLE_LANGUAGE_SELECTION_VISIBILITY,
    payload: {
        show
    }
})

export const loadLanguageServiceFromServer: ActionCreator<LoadLanguageServiceFromServerAction> = (textLibrary: LanguageResourceServiceDto) => ({
    type: LOAD_LANGUAGE_SERVICE_FROM_SERVER,
    payload: {
        textLibrary
    }
})



// WEBPACK FOOTER //
// ./src/store/LanguageLocale/actions.ts